import { render, staticRenderFns } from "./section.vue?vue&type=template&id=6f498ce0&scoped=true&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"
import style0 from "./section.vue?vue&type=style&index=0&id=6f498ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f498ce0",
  null
  
)

export default component.exports